import React from 'react'

export type InterpreterNotification = {
  id: string
  title: string
  subtitle: string
}

export type InterpreterScheduleItem = {
  id: string
  time: string
  client: string
  location: string
}

type InterpreterScheduleProps = {
  heading: string
  rangeLabel: string
  notification: InterpreterNotification
  items: InterpreterScheduleItem[]
}

export function InterpreterSchedule({ heading, rangeLabel, notification, items }: InterpreterScheduleProps) {
  return (
    <div className='d-flex flex-column gap-4'>
      {/* <div className='rounded-3 p-3' style={{ border: '1px solid #e8eaed', backgroundColor: '#ffffff' }}>
        <p className='text-uppercase fw-semibold mb-1' style={{ fontSize: '10px', letterSpacing: '0.08em', color: '#7e8299' }}>
          {notification.title}
        </p>
        <p className='mb-0 fw-semibold' style={{ fontSize: '13px', color: '#181c32' }}>
          {notification.subtitle}
        </p>
      </div> */}

      <div className='d-flex align-items-center justify-content-between mb-4'>
        <h5 className='mb-0 fw-semibold text-uppercase' style={{ fontSize: '10px', letterSpacing: '0.08em', color: '#7e8299' }}>
          {heading}
        </h5>
        <span className='text-uppercase' style={{ fontSize: '8px', fontWeight: 800, color: '#a3a242', letterSpacing: '0.1em' }}>
          {rangeLabel}
        </span>
      </div>

      <div className='rounded-3 p-3' style={{ border: '1px solid #e8eaed', backgroundColor: '#ffffff' }}>
        <div className='d-flex flex-column gap-3'>
          {items.map((item) => (
            <div key={item.id} className='d-flex gap-3 pb-3' style={{ borderBottom: '1px solid #eef0f4' }}>
              <div className='flex-shrink-0 mt-1'>
                <img src='/media/icons/duotune/general/gen024.svg' alt='Time' style={{ width: '15px', height: '15px', opacity: 0.55 }} />
              </div>
              <div className='flex-grow-1'>
                <p className='fw-semibold mb-1' style={{ fontSize: '10px', letterSpacing: '0.03em', color: '#a3a242' }}>
                  {item.time}
                </p>
                <p className='fw-semibold mb-1' style={{ fontSize: '13px', color: '#181c32' }}>
                  {item.client}
                </p>
                <p className='mb-0' style={{ fontSize: '11px', color: '#7e8299' }}>
                  {item.location}
                </p>
              </div>
            </div>
          ))}
          <div className='text-center pt-1'>
            <span style={{ color: '#d0d4d9', fontSize: '16px' }}>...</span>
          </div>
        </div>
      </div>
    </div>
  )
}
